<template>
  <nav v-if="effectiveLastPage > 1" aria-label="Pagination">
    <ul class="ec-pagination pagination">
      <li class="page-item" :class="{ disabled: effectivePage <= 1 }">
        <button class="page-link" @click="goTo(effectivePage - 1)">&laquo;</button>
      </li>
      <li
        v-for="page in pages"
        :key="page"
        class="page-item"
        :class="{ active: page === effectivePage }"
      >
        <button class="page-link" @click="goTo(page)">{{ page }}</button>
      </li>
      <li class="page-item" :class="{ disabled: effectivePage >= effectiveLastPage }">
        <button class="page-link" @click="goTo(effectivePage + 1)">&raquo;</button>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'EcPagination',

  model: {
    prop: 'value',
    event: 'input',
  },

  props: {
    value: { type: Number, default: null },
    currentPage: { type: Number, default: null },
    totalPages: { type: Number, default: 1 },
    lastPage: { type: Number, default: null },
    maxVisible: { type: Number, default: 5 },
  },

  computed: {
    effectivePage() {
      return this.value || this.currentPage || 1
    },
    effectiveLastPage() {
      return this.totalPages || this.lastPage || 1
    },
    pages() {
      var total = this.effectiveLastPage
      var current = this.effectivePage
      var max = this.maxVisible

      if (total <= max) {
        return Array.from({ length: total }, function (_, i) { return i + 1 })
      }

      var half = Math.floor(max / 2)
      var start = Math.max(1, current - half)
      var end = Math.min(total, start + max - 1)

      if (end - start < max - 1) {
        start = Math.max(1, end - max + 1)
      }

      return Array.from({ length: end - start + 1 }, function (_, i) { return start + i })
    },
  },

  methods: {
    goTo(page) {
      if (page >= 1 && page <= this.effectiveLastPage && page !== this.effectivePage) {
        this.$emit('input', page)
        this.$emit('update:current-page', page)
        this.$emit('update:currentPage', page)
      }
    },
  },
}
</script>
